import { createSlice } from "@reduxjs/toolkit";

export type ErrorBoundaryState = {
  errors: string[];
};

const initialState: ErrorBoundaryState = {
  errors: [],
};

const errorLimit = 5; // maximum umber of errors to store in state

/** Error Boundary Slice */
const { reducer, actions } = createSlice({
  name: "errorBoundarySlice",
  initialState,
  reducers: {
    addError: (state, { payload }) => {
      if (state.errors.length >= errorLimit) {
        state.errors.shift();  // remove the oldest error
      }
      state.errors = [...state.errors, payload];  // add the new error
    },
  },
});

export const { addError } = actions;

export default reducer;
